import React from 'react'
import Img from "gatsby-image";

import HeroSmall from '../components/HeroSmall'
import LocationMicroNav from '../components/LocationMicroNav'
import LocationContent from '../components/LocationContent'
import LocationRelated from '../components/LocationRelated'

class ProvidenceLocation extends React.Component {
  render() {
    return (
      <div>
        <HeroSmall location="Providence, RI" />
        <LocationMicroNav />

        <LocationContent 
          category="PlacesForBikes" 
          title="BIKE in PVD"
          story="Providence's most recent bike plan includes City Walk, a four-mile corridor that will run through downtown to Roger Williams Park, linking some major long-distance recreational trails. The state tore down a section of I-95 through the heart of downtown a few years ago, leaving big open fields that are being redeveloped, with plans to include a good bike facility. Providence has a hard-working crew of bike advocates, some great city staffers and a mayor who is really excited about biking."
        />  
        <Img
          title="Providence"
          alt="City Walk in Providence"
          sizes= { this.props.data.providenceImage.sizes }
        />   

       <LocationRelated 
          prevLocationName="Colorado"
          prevLocationPath="colorado"
          prevLocationImgPath= { this.props.data.providencePrevImage }
          nextLocationName="California"
          nextLocationPath="california"
          nextLocationImgPath= { this.props.data.providenceNextImage }
        /> 
      </div>
    )
  }
}

export default ProvidenceLocation

// GraphQL query
export const ProvidenceImageQuery = graphql`
  query ProvidenceImageQuery {
    providenceImage: imageSharp(id: { regex: "/PFB_ProvidenceRI/" }) {
      sizes(maxWidth: 1600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    providencePrevImage: imageSharp(id: { regex: "/PFB_COLORADO/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    },
    providenceNextImage: imageSharp(id: { regex: "/PFB_CALIFORNIA/" }) {
      sizes(maxWidth: 600 ) {
        ...GatsbyImageSharpSizes_withWebp
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/providence.js